/**
 * Caret tip offsets for Map/MarkerPopup — measured from Figma Tooltip frames
 * on the 300px card (node 5140:9533).
 *
 * - Bottom middle: Tooltip x=142, w=16 → tip at 150px (50%)
 * - Bottom left: Tooltip x=0, w=28 → tip at slot center = 14px from left
 * - Bottom right: Tooltip x=272, w=28 → tip at 286 = 14px from right
 *
 * CSS border triangles: tip is the center of the border box, not the
 * positioned margin edge — CaretRow centers with -translate-x/y-1/2.
 */
export const MARKER_POPUP_TIP = {
	/** Centered middle arrows (Bottom/Top/Left/Right middle). */
	middleRatio: 0.5,
	/**
	 * Distance from the card's outer edge to the caret tip for corner arrows
	 * (Bottom/Top left|right, Left/Right top|bottom).
	 */
	cornerInsetPx: 14,
	/** Figma Tooltip height (caret protrusion toward the marker). */
	caretHeightPx: 6,
	/** Figma middle Tooltip width. */
	middleSlotPx: 16,
	/** Figma corner Tooltip width (or height for side arrows). */
	cornerSlotPx: 28,
	/**
	 * Half of the CSS triangle base (`border-x-8` / `border-y-8` = 8px).
	 * Used when documenting tip vs margin-edge offset.
	 */
	caretHalfBasePx: 8,
} as const;
